module.exports = __webpack_public_path__ + "img/modulo_Titulo.10b7a3b.svg";